<template>
  <div class="container-lg" style="margin-bottom: 50px">
    <div id="image-grid" class="row container-grid projects-wrapper justify-content-md-left">
      <div class="col-lg-4 col-md-6 col-12 spacing mt-3 branding" v-for="(item, index) in showImages" :key="index">
        <div class="card border-0 work-container work-grid position-relative d-block overflow-hidden rounded">
          <div class="card-body p-0">
            <a class="mfp-image d-inline-block" href="javascript: void(0);" @click="() => showImg(index)" title="">
              <img :src="item" class="img-fluid" alt="sauna-image" />
            </a>
          </div>
        </div>
      </div>
      <!--end col-->
      <vue-easy-lightbox
        :visible="visible"
        :index="index"
        :imgs="showImages"
        @hide="visible = false"
      ></vue-easy-lightbox>
    </div>
    <div class="row mt-3 justify-content-center">
      <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" @change="changePage"></b-pagination>
    </div>
    <!--end row-->
  </div>
</template>

<script>
import VueEasyLightbox from 'vue-easy-lightbox';

export default {
  name: 'ImageTiles',
  data() {
    return {
      showImages: [],
      currentPage: 1,
      perPage: 9,
      rows: 3,
      visible: false,
      index: 0, // default: 0,
    };
  },
  components: {
    VueEasyLightbox,
  },
  methods: {
    showImg(index) {
      this.index = index;
      this.visible = true;
    },
    changePage(idx) {
      this.refreshImageList(idx);
    },
    refreshImageList(idx) {
      // console.log(this.currentPage);
      // let idx = this.currentPage;

      let startIdx = (idx - 1) * this.perPage;
      let endIdx = startIdx + this.perPage;
      console.log(idx, startIdx, endIdx);
      this.showImages = this.images.slice(startIdx, endIdx);
    },

    refreshImages() {
      this.rows = this.images.length;
      this.refreshImageList(1);
    },
  },
  created() {
    this.refreshImages();
  },
  props: {
    images: Array,
    showPage: Boolean,
  },

  watch: {
    images(newVal) {
      //console.log(newVal);
      this.refreshImages();
    },
  },
};
</script>

<style scoped></style>
